module.exports = __webpack_public_path__ + "media/seq2.mov.ea5af521.mp4";